import { Box, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Page } from "@ui/page/Page";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { GD } from "src/GD";
import { Sessions } from "../forms/Sessions";
import { ProjectSettingsPopup } from "../popup/ProjectSettingsPopup";
import { checkFeature, TAvailableFeatures } from "src/Featuresmap";
import { StatView } from "../StatView";
import { useRef, useState } from "react";
import { useDimensions } from "src/utils/useDimensions";
import { CreditCard, Gauge, Settings as SettingsIcon, Undo2 } from "lucide-react";
import { ClientChargebacks } from "./clientPage/subpages/ClientChargebacks";
import { useTranslation } from "react-i18next";

// const initialDate: Date = new Date();

// const initialParams: IBalancerStatRequest = {
// 	currency: "EUR",
// 	offset: 0,
// 	yyyymm: YYYYMMDDHH(initialDate, "yyyymm"),
// };

export const DashboardPage = () => {
	const { t } = useTranslation();
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();
	const [settingsProjectId, setSettingsProjectId] = useState<number | null>(null);
	const canViewSettings = checkFeature("settings");
	//const theme = useTheme() as ITheme;

	// const [filter, _setFilter] = useState<IBalancerStatRequest>({
	// 	...initialParams,
	// });

	//const [_responseData, setResponseData] = useState<IBalancerStatData | undefined | null>(undefined);
	//!TODO: show loading;
	//const [_busy, setBusy] = useState<boolean>();
	//!TODO: show error;
	 
	//const [_error, setError] = useState<IError>();

	// useEffect(() => {
	// 	const updateData = async () => {
	// 		setError(undefined);
	// 		setResponseData(undefined);

	// 		setBusy(true);

	// 		const project = await GD.REQ_CURRENT_PROJECT.request();
	// 		if (!project?.id) return;

	// 		const res = await GD.BALANCER.REQ_STAT.request({ ...filter, target_id: project.id, target_type: "project" });
	// 		if (!res.error) {
	// 			setResponseData(res.data);
	// 		} else {
	// 			setError(res.error);
	// 		}
	// 		setBusy(false);
	// 	};

	// 	if (filter) updateData();
	// }, [filter]);

	const pageRef = useRef<HTMLDivElement>(null);
	const { width } = useDimensions(pageRef);
	let statSize = 4;
	if (width < 500) statSize = 1;
	else if (width < 740) statSize = 2;
	else if (width < 1150) statSize = 3;
	//statSize = 3;

	return (
		<Page
			label={t("dashboard.title", { project: project?.name ?? "Payswix" })}
			description={t("dashboard.description")}
			icon={<Gauge size={20} />}
			sectionRightContent={
				canViewSettings && (
					<Button
						variant="secondarySmall"
						icon={<SettingsIcon size={16} />}
						sx={{ flexShrink: 0 }}
						disabled={!project}
						onClick={() => project && setSettingsProjectId(project.id)}>
						{t("dashboard.tabs.settings")}
					</Button>
				)
			}
			sx={{ boxShadow: "none", flex: 1, backgroundColor: "transparent", padding: "0px", borderRadius: "0px" }}>
			<Box ref={pageRef} sx={{ padding: "0px", display: "flex", flexDirection: "column", flex: 1 }}>
				{/* <Calendar mode="range" /> */}

				<VBox sx={{ padding: "10px", flex: 1 }}>
					<Tabs variant="modern" checkFeature={feature => checkFeature(feature as TAvailableFeatures)}>
						{/* <TabItem title="Overview">
							<Box sx={{ padding: "0px" }}>
								<Spacer size="10px" />
								<Tile>
									<Box sx={{ width: "min-content" }}>
										<MonthSelector
											onSelect={date => {
												setFilter({ ...filter, yyyymm: date });
											}}
											initialValue={initialDate}
										/>
									</Box>
								</Tile>

								<Spacer size="20px" />

								<Typo variant={"text"} color="textSecondary" weight="600" block>
									Data taken:{" "}
									{responseData ? (
										` ${new Date(responseData.taken).toLocaleDateString()} ${new Date(responseData.taken).toLocaleTimeString()}`
									) : (
										<Skeleton busy mode="manual" sx={{ display: "inline-block" }} shape="line" width={200} height={"0.9rem"} />
									)}
								</Typo>

								<Spacer size="20px" />

								<Box
									sx={{
										display: "grid",
										gap: "18px",
										gridAutoFlow: "dense",
										gridAutoRows: "auto",
										gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
									}}>
									<Box
										sx={{
											gridColumn: "auto / span 2",
											gridRow: "auto / span 2",
										}}>
										<Informer
											title={"Overall conversion"}
											contentFullHeight
											content={
												<Box
													sx={{
														maxWidth: "200px",
														width: "100%",
														height: "100%",
														alignSelf: "center",
													}}>
													<Skeleton shape="circle" mode="manual" center busy={!responseData || busy} width={199}>
														<DonutIndicator value={responseData?.conversion ?? 0} />
													</Skeleton>
												</Box>
											}
										/>
									</Box>
									{responseData?.top?.map(statTop => (
										<Box key={statTop.lable} sx={{ gridColumn: "auto / span 2" }}>
											<Informer
												spacerHeight="0px"
												contentFullHeight
												busy={busy}
												title={statTop.lable}
												content={
													<HBarChartSectional
														legend
														maxItems={10}
														settings={{
															colors: [theme.colors.chartForeground, theme.colors.fail],
															legend: ["Success transactions", "Fail transactions"],
														}}
														gap={8}
														values={statTop.data.map(item => ({
															name: item.name,
															values: [item.success_trx_count, item.fail_trx_count],
														}))}
													/>
												}
											/>
										</Box>
									))}
									<Box sx={{ gridColumn: "auto / span 2" }}>
										<StatBlockContainer
											contentFullHeight
											stat={{
												all: responseData?.turnover,
												success: responseData?.success,
												fail: responseData?.fail,
											}}
											title="Today turnover"
										/>
									</Box>

									
								</Box>
							</Box>
						</TabItem> */}

						{/* Wait for the real width before mounting StatView: statSize depends on it,
						    and a 0 -> real width jump would change StatView's `size` prop and trigger
						    a second overview/get fetch (extra fade-in/out flicker on first load). */}
						<TabItem title={t("dashboard.tabs.overview")} icon={<Gauge size={16} />}>
							{project && width > 0 && <StatView size={statSize} client_id={project.id} type="project" />}
						</TabItem>

						<TabItem title={t("dashboard.tabs.payments")} icon={<CreditCard size={16} />}>
							<Sessions target_id={0} target_type="project" />
						</TabItem>

						<TabItem title={t("dashboard.tabs.chargebacks")} icon={<Undo2 size={16} />}>
							<ClientChargebacks />
						</TabItem>
					</Tabs>
				</VBox>
			</Box>
			{canViewSettings && project && settingsProjectId === project.id && (
				<ProjectSettingsPopup projectId={project.id} projectName={project.name} onClose={() => setSettingsProjectId(null)} />
			)}
		</Page>
	);
};
